import { StyleSheet, View } from 'react-native'

// styles
import { globalStyles } from '../../static/styles/global'

// components
import HomeDetailsHeader from '../../components/home/HomeDetailsHeader'
import Card from '../../components/shared/card/Card'
import UniversalWebView from '../../components/shared/navigator/UniversalWebView'

const HelpScreen = ({ route }): JSX.Element => {
  const {
    params: { staticDocumentPath }
  } = route

  return (
    <>
      <View
        style={[globalStyles.primaryBgColor, globalStyles.containerBandMenu]}
      >
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader />
        </View>
      </View>
      <View style={[globalStyles.flexOne, globalStyles.containerOverlap]}>
        <Card style={styles.webViewCard}>
          <UniversalWebView
            iframeProps={{
              src: `${staticDocumentPath}${'Workhappy_Employee_Manual.pdf'}?v=${Math.random()}`,
              style: { flex: 1, width: '100%', height: '100%', border: 0 }
            }}
            webviewProps={{
              originWhitelist: ['*'],
              allowFileAccess: true,
              javaScriptEnabled: true,
              domStorageEnabled: true,
              automaticallyAdjustContentInsets: true,
              scalesPageToFit: true,
              startInLoadingState: false,
              contentInset: { top: 0, right: 0, left: 0, bottom: 0 },
              scrollEnabled: true,
              style: { flex: 1 },
              source: {
                uri: `${staticDocumentPath}${'Workhappy_Employee_Manual.pdf'}?v=${Math.random()}`
              }
            }}
          />
        </Card>
      </View>
    </>
  )
}

const styles = StyleSheet.create({
  webViewCard: {
    flex: 1,
    paddding: 0,
    margin: 0
  }
})

export default HelpScreen
